import { useEffect, useState } from 'react';
import { getMainHouse } from '@/utils/jsBridge';
import { isLocal, isInZhuzher } from '@/utils/env';

const obj = {
  building_code: '440300069999999999999',
  building_name: '深圳荔景大厦虚拟楼栋',
  city_code: '440300',
  city_name: '深圳市',
  code: '4403000699999999999999999999',
  count: '3',
  identity: 99,
  is_main: true,
  safe_code: '182D8',
  name: '服务中心',
  project_code: '44030006',
  project_name: '深圳荔景大厦',
  project_radius: 60.3516614086,
  project_sensing_radius: 100,
  project_stage: 4,
  project_mid_latitude: '22.5515445556',
  project_mid_longitude: '114.111632333',
};
// const obj3 = {
//   building_code: '440300119999999999999',
//   building_name: '深圳金色家园虚拟楼栋',
//   city_code: '440300',
//   city_name: '深圳市',
//   code: '4403001199999999999999999999',
//   count: '5',
//   identity: 99,
//   is_main: true,
//   name: '服务中心',
//   project_code: '44030011',
//   project_mid_latitude: '22.559932',
//   project_mid_longitude: '114.0508258',
//   project_name: '深圳金色家园',
//   project_radius: 167.326659336,
//   project_sensing_radius: 100,
//   project_stage: 4,
//   safe_code: '9OQO9',
// };
// const obj1 = {
//   project_code: '44030011',
//   project_name: '深圳金色家园',
//   building_code: '440304013200011000001',
//   building_name: '深圳金色家园一期1栋',
//   city_code: '440300',
//   city_name: '深圳市',
//   code: '4403040132000110000010101013',
//   name: '一期1栋101',
//   count: '419',
//   // 90
//   // identity: 90,
//   identity: 0,
//   project_mid_latitude: '22.559932',
//   project_mid_longitude: '114.0508258',
//   project_stage: 4,
//   safe_code: '',
//   unit: '1',
//   _main: false,
// };
// const obj33 = {
//   building_code: '440304013200011000006',
//   building_name: '深圳金色家园二期6栋',
//   city_code: '440300',
//   city_name: '深圳市',
//   code: '4403040132000110000060128047',
//   count: '4',
//   identity: 1,
//   is_main: true,
//   safe_code: '',
//   name: '二期6栋2804',
//   project_code: '44030011',
//   project_name: '深圳金色家园',
//   project_radius: 167.326659336,
//   project_sensing_radius: 100,
//   project_stage: 4,
//   project_mid_latitude: '22.559932',
//   project_mid_longitude: '114.0508258',
//   unit: '1',
// };

// const obj2 = {
//   building_code: '1003A11000000000XL60',
//   building_name: '万科大厦',
//   city_code: '440300',
//   city_name: '深圳市',
//   code: '1003A11000000000XL73',
//   count: '2',
//   identity: 6,
//   is_main: true,
//   safe_code: 'S9OHD',
//   name: '203',
//   project_code: '44030999',
//   project_name: '梅林路63号',
//   project_radius: 71.185625431,
//   project_sensing_radius: 100,
//   project_stage: 4,
//   project_mid_latitude: '22.5735735',
//   project_mid_longitude: '114.0687775',
//   unit: '1',
// };

// 0 业主, 1 家属, 2 租客, 6 住户-已通过审核
// const roleList = [0, 1, 2, 6];

// 获取房屋信息
export default function useMainHouseModel() {
  const [mainHouse, setMainHouse]: any = useState({});

  useEffect(() => {
    if (!Object.keys(mainHouse)?.length) {
      if (isLocal) {
        // 水账户需要
        console.log('useMainHouse isLocal:', isLocal);
        setMainHouse(obj);
      }
      if (isInZhuzher) {
        getMainHouse((res: any) => {
          setMainHouse(res.data);
        });
      }
    }
  }, [mainHouse]);

  return {
    mainHouse,
  };
}
